import React from "react";
import {useTranslation} from "react-i18next";

const InvoiceBusinessSection = ()=>{
    const {t}=useTranslation('invoicepage');
    return(
        <section className="invoice-business-section mt-8 section-container">
            <div className="left-invoice-business-section">
                <div className="left-invoice-business-section-content">
                {t('left-invoice-business-section.line1')}
                <p>{t('left-invoice-business-section.line2')}
                <br/>{t('left-invoice-business-section.line3')}</p>
                <button className="btn-small btn-primary btn-mobile">{t('left-invoice-business-section-button')} &#8594;</button>
                </div>
            </div>
            <div className="right-invoice-business-section">
                <div className="right-invoice-business-section-content">
                    <div id="right-invoice-business-section-box1">
                    <img src="/images/stay-audit-ready.png" alt="stay-audit-ready"/> {t('right-invoice-business-section-box1.line1')}
                    <p>{t('right-invoice-business-section-box1.line2')}</p>

                    </div>
                    <div id="right-invoice-business-section-box2">
                    <img src="/images/fast-and-efficient.png" alt="fast-and-efficient"/> {t('right-invoice-business-section-box2.line1')}
                    <p>{t('right-invoice-business-section-box2.line2')}</p>
                    </div>
                    <div id="right-invoice-business-section-box3">
                    <img src="/images/designed-for-smes.png" alt="designed-for-smes"/> {t('right-invoice-business-section-box3.line1')}
                    <p>{t('right-invoice-business-section-box3.line2')}</p>  
                    </div>
                    <div id="right-invoice-business-section-box4">
                    <img src="/images/tailored-for-b2b-b2c.png" alt="tailored-for-b2b-b2c"/> {t('right-invoice-business-section-box4.line1')}
                    <p>{t('right-invoice-business-section-box4.line2')}</p>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default InvoiceBusinessSection;